// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"79cc29c3","361":"a1a4497c","511":"6022c01e","767":"5bc99e4b"}[chunkId] + ".chunk.js";
};